export default __webpack_public_path__ + "static/blue-cards-cd48ce4495bb118710a72f0bec922e13.png";